import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster as SonnerToaster } from "sonner";
import CookieBanner from "./components/CookieBanner";
import { PageviewTracker } from "./components/PageviewTracker";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { ChatWidget } from "./components/ChatWidget";
import { PromoDock } from "./components/PromoDock";

import { AuthProvider } from "./contexts/AuthContext";
import {
  CustomerLoginPage,
  CustomerRegisterPage,
  CustomerAccountPage,
  ForgotPasswordPage,
  ResetPasswordPage,
} from "./pages/CustomerPages";
import {
  CategorySEOPage,
  BlogPage,
  BlogArticlePage,
} from "./pages/SEOPages";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TerminiPage, ResiPage } from "./pages/LegalPages";
import {
  ChiSiamoPage,
  ContattoPage,
  NewsletterUnsubscribePage,
  StripeSuccessPage,
  SatispaySuccessPage,
} from "./pages/StaticPages";
import { HomePage } from "./pages/HomePage";
import AdvertisingPage from "./pages/AdvertisingPage";
import { ProdottiPage } from "./pages/ProdottiPage";
import { ProductDetailPage } from "./pages/ProductDetailPage";
import {
  CustomPaymentPage,
  CustomPaymentSuccessPage,
  CustomPaymentCancelledPage,
  CustomPaymentShortLinkPage,
} from "./pages/CustomPaymentPage";
import { LoginPage, Dashboard, ProtectedRoute } from "./pages/admin/AdminApp";
import NotFoundPage from "./pages/NotFoundPage";
import { SummerClosureBanner } from "./components/SummerClosureBanner";
import { ShippingDelayNotice } from "./components/ShippingDelayNotice";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <AppErrorBoundary>
      <div className="App">
        <CookieBanner />
        <AuthProvider>
          <BrowserRouter>
            <PageviewTracker />
            <ShippingDelayNotice />
            {/* Avviso chiusura estiva (fino al 31/08/2026, nascosto in /gestione) */}
            <SummerClosureBanner />
            <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/prodotti" element={<ProdottiPage />} />
            <Route path="/prodotto/:id" element={<ProductDetailPage />} />
            <Route path="/chi-siamo" element={<ChiSiamoPage />} />
            <Route path="/contatto" element={<ContattoPage />} />
            <Route path="/termini" element={<TerminiPage />} />
            <Route path="/resi" element={<ResiPage />} />
            <Route path="/return-policy" element={<ResiPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/pubblicita" element={<AdvertisingPage />} />
            <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribePage />} />
            <Route path="/checkout/success" element={<StripeSuccessPage />} />
            <Route path="/satispay-success" element={<SatispaySuccessPage />} />

            {/* Custom payment links (admin-generated) */}
            <Route path="/paga" element={<CustomPaymentPage />} />
            <Route path="/paga/grazie" element={<CustomPaymentSuccessPage />} />
            <Route path="/paga/annullato" element={<CustomPaymentCancelledPage />} />
            <Route path="/p/:short_id" element={<CustomPaymentShortLinkPage />} />

            {/* SEO category pages */}
            <Route path="/collezione/truck-tuning" element={<CategorySEOPage category="Truck Tuning Collection" />} />
            <Route path="/collezione/racing-car-transporters" element={<CategorySEOPage category="Racing Car Transporters" />} />
            <Route path="/collezione/pokemon-tcg" element={<CategorySEOPage category="Pokemon" />} />
            <Route path="/collezione/auto-da-corsa-f1" element={<CategorySEOPage category="Auto da corsa" />} />

            {/* Blog */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />

            {/* Customer account routes */}
            <Route path="/login" element={<CustomerLoginPage />} />
            {/* SEO: legacy /accedi URL indexed by Google — 301 to /login */}
            <Route path="/accedi" element={<Navigate to="/login" replace />} />
            <Route path="/registrazione" element={<CustomerRegisterPage />} />
            <Route path="/account" element={<CustomerAccountPage />} />
            <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            {/* Admin management system */}
            <Route path="/gestione/login" element={<LoginPage />} />
            <Route
              path="/gestione"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* Fallback — 404 with noindex to prevent Soft-404 in Search Console */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <ChatWidget />
          {/* Promo dock unificato: Klarna, sconto 10% e dogana UE come pill
              compatte in basso a sinistra — mai sopra i contenuti. */}
          <PromoDock />
          {/* Global toast host — enables toast.error / toast.success across the app.
              Without this, `sonner` calls are silent (was the root cause of the
              "Paga" button appearing broken on CustomPaymentPage: validation
              errors fired toasts that never rendered). */}
          <SonnerToaster position="top-center" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
      </div>
    </AppErrorBoundary>
  );
}

export default App;
